import styled from 'styled-components';

/* VersionHistory */

export const VersionHistoryDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    background-color: white;
`;

export const CenterPanelDiv = styled.div`
    margin: 70px;
    height: calc(100% - 50px);
`;

export const DivPadding = styled.div`
    padding: 10px;
`;

export const ButtonDiv = styled.div`
    width: auto;
    height: 30px;
    position: absolute;
    left: calc(50% + ${({ isCurrentVersion }) => (isCurrentVersion ? '10px' : '0px')});
    top: 0px;
    background: transparent;
    display: flex;
    align-items: center;
    padding: 10px 0px;
    margin-right: 2px;
`;

export const LoadingDiv = styled.div`
    width: calc(100% - 300px);
    height: calc(100% - 78px);
    border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    background-color: ${({ theme }) => theme.colors.neutral000};
    top: 64px;
    right: 40px;
    position: absolute;
`;

export const LoadingImg = styled.img`
    display: block;
    margin: 50px auto 10px;
`;

export const LoadingText = styled.p`
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.neutral900};
`;

export const PreviewDiv = styled.div`
    position: absolute;
    top: 64px;
    right: 40px;
    width: calc(100% - 298px);
    height: calc(100% - 60px);
    margin: 8px auto;
`;

export const PreviewInnerDiv = styled.div`
    padding: 0;
    width: 800px;
    margin: 8px auto;
    box-sizing: border-box;
    height: calc(100% - 65px);
`;

export const LeftPanelOuterDiv = styled.div`
    width: 270px;
    height: 100%;
`;

/* VersionHistoryLeftPanel */

export const LeftPanelDiv = styled.div`
    width: 270px;
    height: 100%;
    background-color: white;
    position: relative;
    user-select: none;
`;

export const LeftPanelInnerDiv = styled.div`
    width: 220px;
    margin: 13px auto;
`;

export const LeftPanelLoadingText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 22px;
    text-transform: uppercase;
    margin-left: 12px;
    margin-bottom: 6px;
`;

/* VersionHistoryList */

export const VersionHistoryOuterDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 76px);
    padding-right: 10px;
    overflow-y: auto;
`;

export const VersionHistoryItemDiv = styled.div`
    font-size: 12px;
    margin-top: 5px;
`;

/* VersionHistoryDateList */

export const VersionHistoryDateListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-top: ${({ isFirstDate }) => (isFirstDate ? 0 : 16)}px;
`;

export const VersionHistoryDateListHeaderText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 22px;
    text-transform: uppercase;
    margin-left: 12px;
    margin-bottom: 6px;
`;

export const VersionHistoryDateListContent = styled.div`
    overflow: hidden;
    max-height: ${({ isCollapsed, maxHeight }) => (isCollapsed ? 0 : maxHeight)}px;
    transition: max-height ease-out ${({ delay }) => delay}s;
`;

/* VersionHistoryItem */

export const VersionHistoryItemListItem = styled.li`
    list-style-type: none;
    padding: 6px;
    border-radius: 3px;
    background: ${({ isSelected, isMouseOver, theme }) => (isSelected || isMouseOver ? theme.colors.neutral000 : theme.colors.white)};
    border: 1px solid ${({ isSelected, theme }) => (isSelected ? theme.colors.primary300 : theme.colors.white)};
    cursor: pointer;
`;

export const VersionHistoryItemText = styled.p`
    color: #000;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin: 0 4px;
    overflow: hidden;
    white-space: nowrap;
`;

export const VersionHistoryItemBoldText = styled(VersionHistoryItemText)`
    font-weight: 700;
`;

export const VersionHistoryItemFadedText = styled(VersionHistoryItemText)`
    color: ${({ theme }) => theme.colors.neutral900};
`;

/* VersionHistoryItemSkeleton */

export const VersionHistoryItemSkeletonText = styled(VersionHistoryItemText)`
    width: fit-content;
    margin: 4px 6px;
    line-height: 14px;
    color: rgba(125, 125, 125, 0);
    background-color: rgba(125, 125, 125, ${({ alpha }) => alpha});
`;

/* VersionHistoryWarningModal */

export const WarningHeader = styled.p`
    color: #444444;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    margin-top: 12px;
`;

export const WarningText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    width: 304px;
`;

export const WarningButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;
